import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { logout } from '../../features/auth/authSlice';
import LoadingSpinner from '../../components/widgets/LoadingSpinner';

const Logout = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const location = useLocation();

  // on component mount, call for our async logout 
  useEffect(() => {    
    dispatch(logout())    
  }, [dispatch])
 
  
  if (authState.isLoggedIn)
    return <LoadingSpinner />
  else 
    return <Navigate to="/" state={location.state}/>
};

export default Logout;